<template>
  <div class="payOrder-list">
    <el-row :gutter="20" class="operate-bar">
      <el-col :span="2" align="left">
        <el-button v-if="hasPermission('order:edit')" icon="el-icon-download" @click="exportPayOrders" v-hasPermission="'order:edit'">导出订单</el-button>
      </el-col>
      <!-- 搜索区域 -->
      <el-col :span="22" align="right">
        <el-form :inline="true" :model="searchForm" class="search-form">
          <el-row>
            <el-form-item label="商户单号">
              <el-input v-model="searchForm.orderNo" placeholder="请输入商户单号" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="组织机构">
              <el-select v-model="searchForm.orgIds" filterable multiple placeholder="请选择组织机构" clearable>
                <el-option v-for="org in userOrgs" :key="org.id" :label="org.orgName" :value="org.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="下单时间区间">
              <el-date-picker
                v-model="searchForm.datetimerange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                >
              </el-date-picker>
            </el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="loadPayOrders">查询</el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
            <el-button @click="showExtend = !showExtend"
              :icon="showExtend ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></el-button>
          </el-row>
          <el-row :gutter="20" v-if="showExtend">
            <el-form-item label="IMEI">
              <el-input v-model="searchForm.imei" placeholder="请输入IMEI" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="支付状态">
              <el-select v-model="searchForm.payStatus" placeholder="请选择支付状态" clearable>
                <el-option :value="0" label="未支付"></el-option>
                <el-option :value="1" label="已支付"></el-option>
                <el-option :value="2" label="已关闭"></el-option>
                <el-option :value="3" label="已退款"></el-option>
              </el-select>
            </el-form-item>
          </el-row>
        </el-form>
      </el-col>
    </el-row>

    <!-- 数据表格 -->
    <el-table :data="payOrders" border stripe style="width: 100%">
      <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
      <el-table-column prop="orderNo" label="商户单号" header-align="center"></el-table-column>
      <el-table-column prop="orgName" label="组织机构名称" header-align="center"></el-table-column>
      <el-table-column prop="imei" label="IMEI" header-align="center"></el-table-column>
      <el-table-column prop="amount" label="支付金额（单位：元）" align="center" :formatter="formatMoney"></el-table-column>
      <el-table-column prop="payStatus" label="支付状态" align="center" width="100">
        <template slot-scope="scope">
          <el-tag 
            :type="
              scope.row.payStatus === 1 ? 'success' : 
              scope.row.payStatus === 0 ? 'warning' : 
              scope.row.payStatus === 2 ? 'info' : 
              scope.row.payStatus === 3 ? 'danger' : 'danger'
            "
          >
            {{ 
              scope.row.payStatus === 1 ? '已支付' : 
              scope.row.payStatus === 0 ? '未支付' : 
              scope.row.payStatus === 2 ? '已关闭' : 
              scope.row.payStatus === 3 ? '已退款' : '未知状态'
            }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="下单时间" 
        :formatter="(row, column, cellValue) => $options.filters.formatTime(cellValue)"
        align="center"></el-table-column>
      <el-table-column prop="payTime" label="支付时间" 
        :formatter="(row, column, cellValue) => $options.filters.formatTime(cellValue)"
        align="center"></el-table-column>
      <el-table-column label="操作" align="center" >
        <template slot-scope="scope">
          <el-tooltip content="查看详情" placement="top">
            <el-button icon="el-icon-document" type="success" circle
              @click="$router.push({ name: 'PayOrderDetail', query: { orderNo: scope.row.orderNo } })"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
      :page-sizes="[10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
      :total="total"></el-pagination>
      
  </div>
</template>

<script>
import payOrderApi from '../../api/payOrder';
import store from '../../store';
import { hasPermission } from '../../utils/hasPermission';

export default {
  name: 'PayOrderList',
  data() {
    return {
      // 表格数据
      payOrders: [], 
      total: 0,
      pageSize: 10,
      currentPage: 1,
      // 搜索表单
      showExtend: false,
      searchForm: {
        orderNo: '',
        orgIds: [],
        payStatus: '',
        datetimerange: [],
        imei: '',
      },
      userOrgs: store.state.user.userInfo.orgs,
    }
  },
  created() {
    this.loadPayOrders()
  },
  methods: {
    // 加载支付订单列表
    loadPayOrders() {
      // 组装请求参数
      const params = {
        searchOrgIds: this.searchForm.orgIds, // 搜索-组织机构ID
        orderNo: this.searchForm.orderNo, // 搜索-商户单号
        imei: this.searchForm.imei,           // 搜索-IMEI
        payStatus: this.searchForm.payStatus,   // 搜索-支付状态
        startTime: this.searchForm.datetimerange?.[0],  // 搜索-日期范围
        endTime: this.searchForm.datetimerange?.[1],    // 搜索-日期范围
        page: this.currentPage,               // 分页-当前页
        size: this.pageSize,                  // 分页-每页条数
        userOrgIds: this.userOrgs.map(org => org.id) // 用户所负责的组织机构ID列表
      };
      payOrderApi.findAll(params).then(response => {
        if (response.success) {
          this.payOrders = response.data.data
          this.total = response.data.total
        } else {
          this.$message.error(response.message)
        }
      }).catch(error => {
        this.$message.error('加载支付订单列表失败：' + error.message)
      })
    },
    // 重置搜索
    resetSearch() {
      this.searchForm = {
        orderNo: '',
        orgIds: [],
        payStatus: '',
        datetimerange: [],
        imei: '',
      };
      this.loadPayOrders()
    },
    // 每页条数变化时
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadPayOrders(); // 重新加载
    },
    // 当前页变化时
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadPayOrders(); // 重新加载
    },
    // 导出支付订单
    exportPayOrders() {
      if (!hasPermission('order:edit')) {
        this.$message.error('无导出订单权限');
        return;
      }
      // 准备导出参数（检索条件 + 用户组织ID）
      const params = {        
        searchOrgIds: this.searchForm.orgIds.length > 0 ? JSON.stringify(this.searchForm.orgIds) : '',
        orderNo: this.searchForm.orderNo || '', // 搜索-商户单号
        imei: this.searchForm.imei || '',           // 搜索-IMEI
        payStatus: this.searchForm.payStatus || '',   // 搜索-支付状态
        startTime: this.searchForm.datetimerange?.[0] || '',  // 搜索-日期范围
        endTime: this.searchForm.datetimerange?.[1] || '',    // 搜索-日期范围
        userOrgIds: JSON.stringify(this.userOrgs.map(org => org.id)) // 用户组织ID（必传，用于权限过滤）
      };

      // 调用API
      payOrderApi.exportPayOrders(params).then(response => {
        // 处理二进制流，创建下载链接
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `订单_${new Date().getTime()}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
      }).catch(err => {
        this.$message.error(`导出失败：${err.message || '网络错误'}`);
      });
    },
    formatMoney(row){
      if (row.amount === null || row.amount === undefined) return '0.00';
      return (row.amount / 100).toFixed(2)
    },
    hasPermission(permCode) {
      return hasPermission(permCode);
    },
  }
}
</script>

<style scoped></style>